var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C9.72 21 6 12.314 6 9C6 7.4087 6.63214 5.88258 7.75736 4.75736C8.88258 3.63214 10.4087 3 12 3C13.5913 3 15.1174 3.63214 16.2426 4.75736C17.3679 5.88258 18 7.4087 18 9C18 12.314 14.28 21 12 21ZM12 12C12.3824 12 12.7611 11.9247 13.1144 11.7783C13.4677 11.632 13.7887 11.4175 14.0591 11.1471C14.3295 10.8767 14.544 10.5557 14.6903 10.2024C14.8367 9.84907 14.912 9.47041 14.912 9.088C14.912 8.70559 14.8367 8.32693 14.6903 7.97363C14.544 7.62033 14.3295 7.29931 14.0591 7.0289C13.7887 6.7585 13.4677 6.544 13.1144 6.39766C12.7611 6.25132 12.3824 6.176 12 6.176C11.2277 6.176 10.487 6.4828 9.9409 7.0289C9.3948 7.57501 9.088 8.31569 9.088 9.088C9.088 9.86031 9.3948 10.601 9.9409 11.1471C10.487 11.6932 11.2277 12 12 12Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.deb8378678d587cce81d974ecfa8cc2d.svg";
export { ForwardRef as ReactComponent };